module.exports = __webpack_public_path__ + "img/activities-6.eb6afc50.jpg";